import {Component, HostListener, ViewChild} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DatePipe, Location } from '@angular/common';
import {
  GET_USER_MEMBER_CLASS,
  LOGIN_MESSAGE_BOARD_POSTS_NEW, LOGIN_MESSAGE_BOARD_REPORT,
  LOGIN_MESSAGE_BOARD_THREADS_NEW,
  LOGIN_MESSAGE_BOARD_THREADS_VIEW_UPDATE, LOGIN_REQUEST_MORE_DETAILS,
  MESSAGE_BOARD_THREADS_SHOW,
} from 'manager/http-constants';
import { MESSAGE_CODE } from 'src/app/shared/constant/message-constant';
import { TOAST } from 'src/app/shared/constant/primeng-constants';
import { LoadingState } from 'src/app/shared/html-parts/loading/loading-state';
import {
  MessageData,
  ToastMessageData,
} from 'src/app/shared/html-parts/message-common/message-data';
import { CommonService } from 'src/app/shared/service/common.service';
import { DbOperationService } from 'src/app/shared/service/db-operation.service';
import {CONSTANT, DATE_FORMAT, DEFAULT_PAGINATION_EVENT, LOADING_KEY} from 'src/app/shared/constant/constant';
import { PlatformComponent } from '../platform.component';
import { LoginService } from 'src/app/shared/service/login.service';
import { SESSION_KEY } from 'src/app/shared/constant/session-constants';
import { Title } from '@angular/platform-browser';
import {API_RESPONSE, INPUT_INFORMATIONS_API_CONSTANT} from '../../../shared/constant/api-constant';
import {Validator} from '../../../shared/validator/validator';
import {Table} from 'primeng/table';
import { DeleteDialogService } from 'src/app/shared/html-parts/confirm-dialog/delete-dialog/delete-dialog.service';
import {ReportDialogComponent} from '../common/report-dialog/report-dialog.component';
import {ConfirmRequestMoreDetailsDialogComponent} from '../common/confirm-request-more-details-dialog/confirm-request-more-details-dialog.component';

@Component({
  selector: 'app-l201',
  templateUrl: './l201.component.html',
  styleUrls: ['./l201.component.scss', '../platform.component.scss'],
})

/**
 * 掲示板スレッド閲覧
 */
export class L201Component extends PlatformComponent {
  @ViewChild('postsTable') postsTable: Table;

  /** 共通部品_通報時ダイアログ */
  @ViewChild(ReportDialogComponent)
  reportDialogComponent: ReportDialogComponent;

  /** common part citing dialog dialog */
  @ViewChild(ConfirmRequestMoreDetailsDialogComponent)
  confirmRequestMoreDetailsDialogComponent: ConfirmRequestMoreDetailsDialogComponent;

  // 画面.検索フォーム
  l201SearchForm: FormGroup = this.formBuilder.group({
    member_id: this.loginUser ? this.loginUser.member_id : '0'
  });

  // 画面.入力フォーム
  l201PostInputForm: FormGroup = this.formBuilder.group({
    content: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'message_board_posts',
          'content',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // 匿名
    is_anonymous: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'message_board_posts',
          'is_anonymous',
          INPUT_INFORMATIONS_API_CONSTANT.CHECKBOX_TYPE
        ),
      ],
    }),
  });

  // 画面.入力フォーム
  l201ViewForm: FormGroup = this.formBuilder.group({
    user_id: this.loginUser ? this.loginUser.user_id : '0'
  });

  // 課題ID
  threadId: string = this.route.snapshot.params.thread_id;

  // 掲示板スレッド閲覧格納先
  detailThread: any;

  totalPostCount: 0;

  showPaginator = true;

  isDropdownOpen = false;
  activeDropdownIndex: number | null = null;
  loginUserId: string | number = 0;
  memberClassId = 0;

  // tslint:disable-next-line:variable-name
  private _isAnonymousChecked = true;

  constructor(
    public route: ActivatedRoute,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loadingState: LoadingState,
    public deleteDialogService: DeleteDialogService,
    private router: Router,
    private messageData: MessageData,
    private location: Location,
    private loginService: LoginService,
    private datePipe: DatePipe,
    private formBuilder: FormBuilder,
    private validator: Validator,
    private titleService: Title
  ) {
    super(route, commonService, dbOperationService, loadingState);
    this.titleService.setTitle('地方創生SDGs官民連携マッチングシステム｜内閣府');
  }

  // tslint:disable-next-line:use-lifecycle-interface
  ngOnInit(): void {
    this.loginService.getAuth0LoginState().subscribe((response) => {
      // ログイン状態をセット

      // ログイン状態を判定
      if (response) {
        // ログイン状態の場合

        /* ログインユーザー情報 */
        // セッションからログインユーザ情報取得
        const loginUser = JSON.parse(
          window.sessionStorage.getItem(SESSION_KEY.loginUserInformation)
        );

        // セッションにログインユーザ情報が存在するか否か
        if (loginUser) {
          // セッションにログインユーザが存在する場合

          this.loginUser = loginUser;

          // 課題・ソリューション結果を取得
          // 辞書値リストを取得
          this.getSpecCodeList(901, 2021, 2026);

          this.checkMemberClass();

          // 掲示板スレッド閲覧を取得
          this.getDetailThread();

          this.updateLastViewDate();

          return;
        } else {
          this.showPaginator = false;
          // セッションにログインユーザが存在しない場合(初回表示時)

          // ログインユーザ情報取得処理
          // tslint:disable-next-line:no-shadowed-variable
          this.loginService.getLoginUser().subscribe((response) => {
            // 正常なユーザの為、セッションにユーザ情報を格納
            window.sessionStorage.setItem(
              SESSION_KEY.loginUserInformation,
              JSON.stringify(response.body[0])
            );

            this.loginUser = JSON.parse(window.sessionStorage.getItem(SESSION_KEY.loginUserInformation));
            // 課題・ソリューション結果を取得
           // 辞書値リストを取得
            this.getSpecCodeList(901, 2021, 2026);

            this.checkMemberClass();

          // 掲示板スレッド閲覧を取得
            this.getDetailThread();

            this.updateLastViewDate();

            return;
          });
        }
      } else {
        // 未ログイン状態の場合
        this.showPaginator = false;

        // 辞書値リストを取得
        this.getSpecCodeList(901, 2021, 2026);

        this.loginUser = null;
        this.memberClassId = 0;

        // 掲示板スレッド閲覧を取得
        this.getDetailThread();
        return;
      }
    });
  }

  /**
   * 掲示板スレッド閲覧を取得
   */
  public getDetailThread(event: any = DEFAULT_PAGINATION_EVENT): void {
    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(MESSAGE_BOARD_THREADS_SHOW);
    this.loginUserId = this.getLoginUserId();

    const l201SearchForm: any = JSON.parse(
      JSON.stringify(this.l201SearchForm.value)
    );

    const pageNo = event.first / event.rows + 1;
    const pageSize = event.rows;

    l201SearchForm.page_no = pageNo;
    l201SearchForm.page_size = pageSize;
    l201SearchForm.member_id = this.getLoginMemberId();

    // 掲示板スレッド閲覧を取得
    this.dbOperationService
      // .getNoTemplateDisplayData(MESSAGE_BOARD_THREADS_SHOW, this.threadId, true)
      .getNoTemplateData(MESSAGE_BOARD_THREADS_SHOW + this.threadId, l201SearchForm, true)
      .subscribe((response) => {
        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, MESSAGE_BOARD_THREADS_SHOW);

        if (this.commonService.checkNoneResponse(response)) {
          // 警告メッセージ
          this.messageData.toastMessage(
            new ToastMessageData({
              severity: TOAST.WARN,
              summary: this.commonService.msg(MESSAGE_CODE.E00003),
              detail: this.commonService.msg(MESSAGE_CODE.E00026),
            })
          );

          this.detailThread = [];

          // 前画面へ戻る
          // this.location.back();
          this.router.navigate(['pages/platform/l101']);
        } else {
          // 掲示板スレッド閲覧を格納
          this.detailThread = response.body[0];
          this.totalPostCount = this.detailThread.posts_count;
        }
    });
  }

  /**
   * 掲示板スレッド閲覧を取得
   */
  public updateLastViewDate(): void {
    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(LOGIN_MESSAGE_BOARD_THREADS_VIEW_UPDATE);

    const l201ViewForm: any = JSON.parse(
      JSON.stringify(this.l201ViewForm.value)
    );
    l201ViewForm.thread_id = this.threadId;
    l201ViewForm.user_id = this.getLoginUserId();

    // 掲示板スレッド閲覧を取得
    this.dbOperationService
      .updateData(LOGIN_MESSAGE_BOARD_THREADS_VIEW_UPDATE, '', l201ViewForm)
      .subscribe((response) => {
        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, LOGIN_MESSAGE_BOARD_THREADS_VIEW_UPDATE);

        // レスポンス結果を判定
        if (API_RESPONSE.SUCCESS == response.body.Message) {
          // 正常終了の場合
          // console.log(response.body);
        } else {
          // 異常終了の場合

          // 異常終了メッセージ
          this.messageData.toastMessage(
            new ToastMessageData({
              severity: TOAST.ERROR,
              summary: this.commonService.msg(MESSAGE_CODE.E00001),
              detail: this.commonService.msg(MESSAGE_CODE.E80002),
            })
          );

          // 会員主催イベント申請登録(E104)を表示する
          this.router.navigate(['pages/platform/l101']);
        }
      });
  }

  public checkRequired(): boolean {
    // 申請区分、継続分科会を取得
    const content = this.l201PostInputForm.get("content").value;

    if ((content == null || content.length == 0 || content == CONSTANT.EMPTY_STRING)) {
      // メッセージを表示させるために対象項目をマーク
      this.l201PostInputForm.controls['content'].markAsDirty();
      // エラーメッセージ設定
      this.l201PostInputForm.controls['content'].setErrors({
        message: '必須項目です。必ず入力してください。',
      });

      return false;
    }

    return true;

  }

  /**
   * 入会申請メールアドレス確認(A203)へ遷移する
   */
  public newPost(): void {
    if (this.checkRequired() === false) {
      return;
    }

    // 画面.入力フォームから入力内容を取得
    // ※値渡し
    const l201PostInputForm: any = JSON.parse(
      JSON.stringify(this.l201PostInputForm.value)
    );

    l201PostInputForm.thread_id = this.threadId;
    l201PostInputForm.is_anonymous = this.isAnonymousChecked;
    l201PostInputForm.member_id = this.getLoginMemberId();
    l201PostInputForm.user_id = this.getLoginUserId();

    if (this.memberClassId == 3) {
      l201PostInputForm.is_anonymous = false;
    }

    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(LOADING_KEY.DATA_INSERT);

    // 会員申請登録を実施
    this.dbOperationService
      .insertData(LOGIN_MESSAGE_BOARD_POSTS_NEW, l201PostInputForm)
      .subscribe((response) => {
        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, LOADING_KEY.DATA_INSERT);

        // レスポンス結果を判定
        if (API_RESPONSE.SUCCESS == response.body.Message) {
          // 正常終了の場合

          this.l201PostInputForm.get('content')?.reset();

          // 掲示板スレッド閲覧を取得
          this.getDetailThread();

          // 最後のページへ遷移
          this.navigateToLastPage();
        } else {
          // 異常終了の場合

          // 異常終了メッセージ
          this.messageData.toastMessage(
            new ToastMessageData({
              severity: TOAST.ERROR,
              summary: this.commonService.msg(MESSAGE_CODE.E00001),
              detail: this.commonService.msg(MESSAGE_CODE.E80002),
            })
          );
        }
      });
  }

  /**
   * ページネーターを最初のページに移動し、ページの一番上にスクロールします。
   */
  navigateToFirstPage(): void {
    const firstPageFirstRecordIndex = 0;
    const rowNum = this.postsTable.rows;

    if (this.detailThread && this.detailThread.posts_count > 0) {
      this.postsTable.first = firstPageFirstRecordIndex;
      this.getDetailThread({ first: firstPageFirstRecordIndex, rows: rowNum });
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      console.warn('最初のページに移動できません。detailThreadとposts_countを確認してください。');
    }
  }


  /**
   * Navigates the paginator to the last page.
   */
  navigateToLastPage(): void {
    const totalRecords = this.detailThread.posts_count;
    const rowNum = this.postsTable.rows;
    const totalPages = Math.ceil(totalRecords / rowNum);
    const lastPageFirstRecordIndex = (totalPages - 1) * rowNum;

    if (lastPageFirstRecordIndex >= 0 && lastPageFirstRecordIndex < totalRecords) {
      this.postsTable.first = lastPageFirstRecordIndex;

      this.getDetailThread({ first: lastPageFirstRecordIndex, rows: rowNum });
    } else {
      console.warn('Unable to navigate to the last page. Check totalRecords and rows.');
    }
  }
  /**
   * re fetch data
   */
  reload(): void {
       // 掲示板スレッド閲覧を取得
       this.getDetailThread();
  }

  get isAnonymousChecked(): boolean {
    return this._isAnonymousChecked;
  }

  set isAnonymousChecked(value: boolean) {
    this._isAnonymousChecked = value;
    this.l201PostInputForm.get('is_anonymous')?.setValue(value ? 1 : 0);
  }

  onAnonymousChange(event: any): void {
    const isChecked = event.checked;
    this.isAnonymousChecked = isChecked;
  }

  /**
   * ページアンカーにスクロール
   */
  public jumpTop(): void {
    const jumpTop = document.getElementById('jump-top');
    window.scrollTo({
      top: jumpTop.offsetTop,
      behavior: 'smooth',
    });
  }

  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
  }
  togglePostDropdown(index: number): void {
    this.activeDropdownIndex = this.activeDropdownIndex === index ? null : index;
  }
  @HostListener('document:click', ['$event'])
  closeDropdown(event: Event): void {
    const target = event.target as HTMLElement;

    if (!target.closest('.menu-container')) {
      this.isDropdownOpen = false;
    }

    if (!target.closest('.post-menu-container')) {
      this.activeDropdownIndex = null;
    }
  }
  deleteThread(threadId: number): void {
    this.deleteDialogService
      .deleteDialog(LOGIN_MESSAGE_BOARD_THREADS_NEW, 'スレッドID', String(threadId), '削除')
      .subscribe(() => {
        this.router.navigate(['pages/platform/l101']);
      });
  }
  reportThread(threadId: number): void {
    this.reportDialogComponent.openReportDialog(
      LOGIN_MESSAGE_BOARD_REPORT,
      String(threadId),
      1,
      '掲示板スレッド',
      0,
      4
    );
  }
  deletePost(postId: number): void {
    this.deleteDialogService
      .deleteDialog(LOGIN_MESSAGE_BOARD_POSTS_NEW, '書き込みID', String(postId), '削除')
      .subscribe(() => {
        // ユーザー結果を取得
        this.getDetailThread();
        this.navigateToFirstPage();
      });
  }
  reportPost(postId: number): void {
    this.reportDialogComponent.openReportDialog(
      LOGIN_MESSAGE_BOARD_REPORT,
      String(postId),
      2,
      'この書き込み',
      0,
      4
    );
  }

  public getDetailInquiry(): void {
    // 画面ロードフラグをON(ロード中状態)

  }

  getDisplayName(post: any): string {
    const isAnonymous = parseInt(post.is_anonymous, 10) === 1;
    if (isAnonymous) {
      switch (parseInt(post.class_id, 10)) {
        case 1:
          return `匿名 ${post.class_name}（${post.prefectures}）`;
        case 2:
        case 9:
          return `匿名 ${post.class_name}`;
        case 3:
          return `匿名 ${post.class_name}（${post.industry_name}）`;
        default:
          return '匿名';
      }
    }
    // Non-anonymous
    else {
      switch (post.class_id) {
        case 1:
          return `${post.organization_name} ${post.department_name} ${post.full_name}`;
        case 2:
        case 3:
          return `${post.organization_name} ${post.full_name}`;
        default:
          return `${post.organization_name || ''} ${post.full_name || ''}`.trim();
      }
    }
  }

  requestMoreDetailsDialog(postId: number): void {
    this.confirmRequestMoreDetailsDialogComponent.openDialog(
      this.loginUser.organization_name,
      Number(this.getLoginMemberId()),
      Number(this.loginUserId),
      postId
    );
  }

  /**
   * 会員種類をチェック
   */
  private checkMemberClass(): void {
    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(GET_USER_MEMBER_CLASS);

    // 掲示板スレッド詳細を取得
    this.dbOperationService
      .getNoTemplateData(GET_USER_MEMBER_CLASS + this.getLoginUserId(), {}, false)
      .subscribe((response) => {
        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, GET_USER_MEMBER_CLASS);
        if (this.commonService.checkNoneResponse(response)) {
          return;
        } else {
          const res = response.body;
          this.memberClassId = res.class_id;
        }
      });
  }



}
